import * as t from "io-ts";
import { LocalizedString } from "@dbn/omnichannel-design-system-g4p";

export const CompanySuggestion = t.type(
  {
    name: LocalizedString,
    id: LocalizedString,
  },
  "CompanySuggestion"
);
export type CompanySuggestion = t.TypeOf<typeof CompanySuggestion>;
